<template>
  <div class="w-256">
    <div class="rounded h-6 border-blue-700 border bg-white w-full overflow-hidden">
      <div
        class="bg-blue-700 h-full"
        :style="{width: percentage + '%'}"
      />
    </div>
    <div class="text-center p-4">
      {{ completed }}/{{ all }} {{ $t('GLOBAL.COMPLETED', 'Completed') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    all: { type: Number, required: true },
    completed: { type: Number, required: true }
  },
  computed: {
    percentage () {
      return this.completed * 100 / this.all
    }
  }
}
</script>
